import { useTheme } from 'styled-components'

import { FlexColumn, Padding } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { ReactNode } from 'react'

type Props = {
  title: string
  description: string
  button?: ReactNode
}

const Empty = ({ title, description, button }: Props) => {
  const theme = useTheme()

  return (
    <Padding py={theme.UI.Spacing.Space18}>
      <FlexColumn alignItems='center' gap={theme.UI.Spacing.Space8} flexGrow={1}>
        <img src={'/img/svg/empty-inbox.svg'} alt='lege inbox' />

        <FlexColumn gap={theme.UI.Spacing.Space4} alignItems='center'>
          <H2 noMargin textAlign='center'>
            {title}
          </H2>
          <Span type='BodyLargeRegular' color={theme.Colors.Neutrals.Darker} textAlign='center'>
            {description}
          </Span>
        </FlexColumn>

        {button}
      </FlexColumn>
    </Padding>
  )
}

export { Empty }
